import React, { useMemo } from "react";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../../../modules/login";
import styled, { withTheme } from "styled-components";
import ProfileCard from "../../../components/ui-library/ProfileCard/ProfileCard";
import CaregiversTable from "../../../components/smart/CaregiversTable/CaregiversTable";

const ContentWithPadding = styled.div`
  padding: 0 20px 30px 60px;
  margin-top: 2.5rem;

  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    padding: 0;
  }
`;
const AdminParticipantCaregivers = (props) => {
  const {
    route,
    studies,
    match: {
      params: { participantUsername, participantId },
    },
  } = props;

  const studyCode = useMemo(
    () =>
      studies?.find(
        (o) => o?.studyId?.toLowerCase() === route?.study?.toLowerCase()
      )?.code ?? "",
    [studies, route]
  );

  const participant = useMemo(
    () => ({ participantId: participantId, userName: participantUsername }),
    [participantUsername, participantId]
  );

  return (
    <>
      <ContentWithPadding>
        <ProfileCard
          title={`${participant.userName}'s caregivers`}
          cardHeader="-green"
          addPadding={true}
          iconClassName="fas fa-users-cog"
        >
          <CaregiversTable studyId={route.study} participant={participant} />
        </ProfileCard>
      </ContentWithPadding>
    </>
  );
};

export default connect((state) => {
  return {
    ...mapStateToPropsLogin(state),
    userData: state?.smartPageHeaderReducer,
    loginReducer: state?.loginReducer,
  };
})(withTheme(AdminParticipantCaregivers));
